import { API } from "@/lib/api";
import { APIService } from "@/services/api";
import {
  ReadDepartmentBasedAssignments,
  WriteDepartmentBasedAssignments,
} from "@/types/departmentBasedAssignments";

export const DepartmentBasedAssignmentsService = new APIService<
  ReadDepartmentBasedAssignments,
  WriteDepartmentBasedAssignments
>(API.DepartmentBasedAssignments);
